import { useMutation } from '@tanstack/react-query'
import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import { usePanelInviteModal } from '@/components/modals/PanelInviteModal/hooks/usePanelInviteModal'
import { useInvalidateQueries } from '@/hooks/useInvalidateQueries'
import useNotyf from '@/hooks/useNotyf'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import { QUERY_KEYS } from '@/lib/queryKeys'
import inviteReferralPartnerService from '@/lib/services/inviteReferralPartnerService'

interface Props {
  inviteReferralPartnerId: number
}

const DeleteDirectInviteButton: React.FC<Props> = ({
  inviteReferralPartnerId,
}) => {
  const notyf = useNotyf()
  const invalidateQueries = useInvalidateQueries()
  const panelInviteModal = usePanelInviteModal()
  const showGenericServerError = useShowGenericServerError()

  const deleteInviteMutation = useMutation({
    mutationFn: () =>
      inviteReferralPartnerService.deleteInvite(inviteReferralPartnerId),
    onSuccess: async () => {
      await invalidateQueries([QUERY_KEYS.panelInvites()])
      panelInviteModal.hide()
      notyf.success('Invite successfully deleted')
    },
    onError: showGenericServerError,
  })

  function handleDelete() {
    const hasConfirmed = window.confirm(
      'Are you sure you want to delete this invite?',
    )

    if (hasConfirmed) {
      deleteInviteMutation.mutate()
    }
  }

  return (
    <ActionButton
      variant="outline-destructive"
      size="sm"
      onClick={handleDelete}
      isProcessing={deleteInviteMutation.isPending}
      isProcessingText="Cancelling"
    >
      Delete invite
    </ActionButton>
  )
}

export default DeleteDirectInviteButton
